import { NgModule } from '@angular/core';
import { TranslocoModule,  provideTransloco, DefaultTranspiler, provideTranslocoTranspiler } from '@jsverse/transloco';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    return this.http.get(`/assets/i18n/${lang}.json`);
  }
}

@NgModule({
  imports: [TranslocoModule, HttpClientModule],
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: ['en','zh','fr','pt'],
        defaultLang: 'en',
        reRenderOnLangChange: true,
        prodMode: false, // Set to `true` in production
      },
      loader: TranslocoHttpLoader,
    }),
    provideTranslocoTranspiler(DefaultTranspiler), // Use DefaultTranspiler
  ],
})
export class TranslocoRootModule {}
